import { ReferenceParser } from "@methodset/calculator-ts";
import { SelectWidgetConfiguration, Widget } from '@methodset/application-client-ts';

export class SelectWidgetSync {

    public static parser = (widget: Widget): string[] => {
        const configuration = widget.configuration as SelectWidgetConfiguration;
        const refs: string[] = [];
        refs.push(...ReferenceParser.extract(configuration.hideId, true));
        refs.push(...ReferenceParser.extract(configuration.label));
        refs.push(...ReferenceParser.extract(configuration.variableId, true));
        return refs;
    }

    public static updater = (widget: Widget, target: string, replacement: string): void => {
        const configuration = widget.configuration as SelectWidgetConfiguration;
        configuration.hideId = ReferenceParser.update(configuration.hideId, target, replacement, true);
        configuration.label = ReferenceParser.update(configuration.label, target, replacement);
        configuration.variableId = ReferenceParser.update(configuration.variableId, target, replacement, true);
    }

}
